import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { entitySauce } from '@State'
import { message } from 'antd'

type useAdminInviteType = {
  storeToken: () => void,
  acceptInvite: () => void
}

const useAdminInvite = (): useAdminInviteType => {
  const searchUrlQuery = useLocation().search

  useEffect(() => {
    const successfullyInvited = localStorage.getItem('successfullyInvited')
    if (successfullyInvited) {
      message.success('Invite accepted successfully')
      localStorage.removeItem('successfullyInvited')
    }
  }, [])

  const [patch] = entitySauce.usePatch(['sponsorAdmins'], {
    onSuccess: () => {
      localStorage.removeItem('inviteToken')
      // Reload the page to ensure all queries fetch fresh data with new permissions
      // This is the most reliable way to handle this race condition
      localStorage.setItem('successfullyInvited', 'true')
      window.location.reload()
    }
  })

  // Store the token from the URL in the local storage.
  // This is needed because the user will be redirected to the login page.
  const storeToken = () => {
    const inviteToken = new URLSearchParams(searchUrlQuery)?.get('token') ?? ''

    if (inviteToken) {
      localStorage.setItem('inviteToken', inviteToken)
    }
  }

  // Accept the invite if the token is stored in the local storage.
  const acceptInvite = () => {
    const inviteToken = localStorage.getItem('inviteToken') ?? new URLSearchParams(searchUrlQuery)?.get('token')

    if (inviteToken) {
      patch({
        token: inviteToken
      })
    }
  }

  return {
    storeToken,
    acceptInvite
  }
}

export default useAdminInvite
